export const RESIZE_THROTTLE_TIME_MS = 300;
